import { interval, Subscription } from "rxjs";
import { switchMap } from "rxjs/operators";
import appStore from "./CacheControlStore";
import { fromFetch } from "rxjs/fetch"; 

// Poll every 5  minutes and fetch latest index.html
const checkVersionStream = interval(300000).pipe(switchMap(() => fetchHtml()));

let checkVersionSubscription: Subscription | null = null;

export const startVersionCheck = () => {
  if (checkVersionSubscription && !checkVersionSubscription.closed) {
    console.log("Version check already running.");
    return; // Prevent duplicate subscriptions
  }

  checkVersionSubscription = checkVersionStream.subscribe((html) => {
    const remoteVersion = getVersionNumberFromHtml(html);

    if (remoteVersion) {
      appStore.setRemoteVersion(remoteVersion);
    }
    console.log("Version checking started.");
  });
};

export function getVersionNumberFromHtml(html) {
  const match = html.match(/window\.APP_VERSION\s*=\s*["'](.+?)["']/);
  const remoteVersion = match ? match[1] : null;
  return remoteVersion;
}

// Function to stop polling
export const stopVersionCheck = () => {
  if (checkVersionSubscription) {
    checkVersionSubscription.unsubscribe();
    console.log("Version checking stopped.");
  }
};

export function fetchHtml() {
  return fromFetch("/index.html?v=" + Date.now()).pipe(
    switchMap((response) => response.text())
  );
}
